import React from "react";
import { NumberInput as MantineNumberInput, NumberInputProps as MantineNumberInputProps } from "@mantine/core";
import styles from "./styles.module.css";

export interface NumberInputProps extends MantineNumberInputProps {
  editable?: boolean;
}

const NumberInput = ({ editable = true, ...props }: NumberInputProps) => {
  return (
    <MantineNumberInput
      {...props}
      className={`${styles.root} ${!editable ? styles.uneditable : ""} no-arrows`}
      hideControls
    ></MantineNumberInput>
  );
};
NumberInput.displayName = "NumberInput";

export default NumberInput;
